import { Modal, Typography, Card, Spin, Divider, Tooltip } from "antd";
import { Person, Phone, CalendarToday } from "@mui/icons-material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useMediaQuery } from "react-responsive";
import { InteressadoAnuncio } from "../../../interfaces/InteressadoAnuncio";
import { useInteressados } from "../hooks/useInteressados";
import { useMemo } from "react";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";
import { formatDate } from "../../../uteis/dateUtils";
import {
  ContainerModal,
  ItemTextModal,
  ItemWrapper,
  TextModal,
} from "../styles";

const { Title } = Typography;

interface Props {
  isModalOpen: boolean;
  handleFechar: () => void;
  interessadoAnuncio: InteressadoAnuncio[] | null;
}

export default function ModalInteressados({
  isModalOpen,
  handleFechar,
  interessadoAnuncio,
}: Props) {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const usuarioIds = useMemo(
    () => (interessadoAnuncio ?? []).map((i) => i.idUsuario),
    [interessadoAnuncio]
  );

  const datasContatos = useMemo(
    () => (interessadoAnuncio ?? []).map((i) => i.created_at),
    [interessadoAnuncio]
  );

  const { interessados, loading } = useInteressados(usuarioIds, datasContatos);

  const abrirWhatsapp = (telefone: string) => {
    const numero = telefone.replace(/\D/g, ""); // só remove símbolos, mantém o número real
    window.open(`https://wa.me/${numero}`, "_blank");
  };

  return (
    <Modal
      open={isModalOpen}
      onCancel={handleFechar}
      footer={null}
      centered
      width={isMobile ? "90%" : 520}
    >
      <Card
        title={
          isMobile ? (
            <Title level={4} style={{ margin: 0 }}>
              Interessados
            </Title>
          ) : (
            <Title level={2} style={{ margin: 0 }}>
              Interessados
            </Title>
          )
        }
        style={{
          width: "100%",
          maxWidth: 520,
          margin: "0 auto",
          borderRadius: "10px",
          padding: "16px",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
        }}
      >
        {loading ? (
          <Spin style={{ display: "block", margin: "20px auto" }} />
        ) : (
          <ContainerModal>
            {interessados.length > 0 ? (
              interessados.map((i, index) => (
                <div key={index}>
                  <ItemWrapper>
                    <ItemTextModal>
                      <Person
                        sx={{ fontSize: 20, marginRight: 4, color: "#555" }}
                      />
                      {i.nome}
                    </ItemTextModal>

                    <TextModal
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Phone
                        sx={{ fontSize: 18, marginRight: 4, color: "#555" }}
                      />
                      {formatPhoneNumber(i.telefone) || "-"}
                      {i.telefone && (
                        <Tooltip title="Conversar no WhatsApp">
                          <WhatsAppIcon
                            onClick={() => abrirWhatsapp(i.telefone)}
                            sx={{
                              fontSize: 22,
                              marginLeft: 8,
                              color: "#25D366",
                              cursor: "pointer",
                              transition: "transform 0.2s",
                              "&:hover": { transform: "scale(1.1)" },
                            }}
                          />
                        </Tooltip>
                      )}
                    </TextModal>

                    <TextModal>
                      <CalendarToday
                        sx={{ fontSize: 18, marginRight: 4, color: "#555" }}
                      />
                      Data Contato: {formatDate(i.dataContato) || "-"}
                    </TextModal>
                  </ItemWrapper>
                  {index < interessados.length - 1 && <Divider />}
                </div>
              ))
            ) : (
              <div style={{ textAlign: "center", width: "100%" }}>
                Nenhum interessado encontrado.
              </div>
            )}
          </ContainerModal>
        )}
      </Card>
    </Modal>
  );
}
